import { api2BaseURL } from "../env";

export class Api2RequestError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

export async function rulebaseApi2Request<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(`${api2BaseURL}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      ...(init.body ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });

  if (response.status === 401) {
    throw new Api2RequestError("Not logged in", response.status);
  }

  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const message =
      body && typeof body === "object" && "error" in body
        ? String(body.error)
        : response.statusText;
    throw new Api2RequestError(
      message || "API2 request failed",
      response.status,
    );
  }

  return body as T;
}
